// eslint-disable-next-line import/no-named-as-default
import gql from 'graphql-tag'
import { buttonFields } from '../elements/buttonFragment.graphql'
import { imageFields } from '../elements/imageFragment.graphql'

export const sectionTextWithImageFields = gql`
  fragment sectionTextWithImageFields on SectionTextWithImageRecord {
    modelApiKey: _modelApiKey
    firstPublishedAt: _firstPublishedAt
    title
    text {
      value
    }
    textLocation
    image {
      ...imageFields
    }
    actions {
      ...buttonFields
    }
    video {
      thumbnailUrl
      url
      width
      height
    }
    displayVideo
  }
  ${buttonFields}
  ${imageFields}
`
